import React from 'react';
import { Line } from 'rc-progress';
import { useDispatch, useSelector } from 'react-redux';
import { ProgressionCourseState } from 'store/modules/progression_course_store/types';
import { ApplicationState } from 'store';
import { CourseState } from 'store/modules/course_store/types';
import { startCourse } from 'store/modules/course_store/actions';
import { Container } from './styles';

const CardProgressIntroduction = () => {
  const dispatch = useDispatch();
  const { course } = useSelector<ApplicationState, CourseState>((state) => state.session.course);
  const { progression_course } = useSelector<ApplicationState, ProgressionCourseState>(
    (state) => state.session.progression_course,
  );

  const totalAulas = Number(progression_course?.total_aula);
  const progression = Number(progression_course?.progression) || 0;

  let buttonText = '';
  if (progression === 0 && totalAulas === 0) {
    buttonText = 'Iniciar curso';
  } else if (totalAulas > 0) {
    buttonText = 'Continuar curso';
  } else if (progression === totalAulas) {
    buttonText = 'Acessar curso';
  }

  const handleButtonClick = () => {
    if (buttonText === 'Iniciar curso') {
      dispatch(startCourse(2));
    } else {
      window.location.href = `/curso`;
    }
  };
  return (
    <Container className="card-container h-100">
      <h5>{course?.name}</h5>
      <span>
        {progression_course?.last_lasson
          ? progression_course.last_lasson.nome
          : course?.topics[0]?.name}
      </span>
      <Line className="py-5" percent={(progression / totalAulas) * 100} strokeColor="#02AF87" />
      <button type="button" className="btn btn-primary btn-sm" onClick={handleButtonClick}>
        {buttonText}
      </button>
    </Container>
  );
};

export default CardProgressIntroduction;
